export const VENDOR_DASHBOARD = '/vendor/dashboard';
export const VENDOR_ADD_CUSTOMER = '/vendor/customers/add';
export const VENDOR_VIEW_CUSTOMER = '/vendor/customers/view/:customerId';
export const VENDOR_EDIT_CUSTOMER = '/vendor/customers/edit/:customerId';
export const VENDOR_CUSTOMERS = '/vendor/customers';

export const VENDOR_CHANGE_PASSWORD = '/vendor/change-password';

export const VENDOR_BOOKING_SUMMARY = '/vendor/bookings/summary';

export const VENDOR_PROFILE_UPDATE = '/vendor/profile';
export const VENDOR_REPORTS = '/vendor/reports';
export const VENDOR_BOOKING_AIRPORT_DETAILS = '/vendor/bookings/airport-data';
export const VENDOR_BOOKING_PASSENGER_DETAILS =
  '/vendor/bookings/passenger-data';
export const VENDOR_BOOKINGS = '/vendor/bookings';
export const VENDOR_VIEW_BOOKINGS = '/vendor/bookings/view/:bookingId';
export const VENDOR_EDIT_BOOKINGS = '/vendor/bookings/edit/:bookingId';

export const VENDOR_INVOICES = '/vendor/invoices';
export const VENDOR_VIEW_INVOICE = '/vendor/invoices/view';
export const VENDOR_SUCCESS_PAGE = '/vendor/bookings/success';
